import React, { useEffect, useState } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Gift, Copy, Twitter, Mail, MessageCircle, Sparkles } from 'lucide-react';
import { getReferral } from '../lib/api';
import { toast } from 'sonner';

const ReferralCard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { getReferral().then(setData).catch(() => {}); }, []);
  if (!data) return null;
  const link = `${window.location.origin}/?ref=${data.code}`;
  const message = `Hey! I'm using CalorieSnap — snap a photo of any meal and it tells you calories & macros. Sign up with my link and we both get a free month of Pro: ${link}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success('Referral link copied!'); }
    catch (e) { toast.error('Copy failed'); }
  };
  const shareTw = () => window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`, '_blank');
  const shareWa = () => window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
  const shareMail = () => window.open(`mailto:?subject=${encodeURIComponent('Try CalorieSnap with me')}&body=${encodeURIComponent(message)}`);

  return (
    <Card className="rounded-3xl border-emerald-950/5 overflow-hidden">
      <div className="bg-gradient-to-br from-emerald-700 to-emerald-800 text-white p-6">
        <div className="flex items-center gap-2 mb-2"><Gift className="w-5 h-5" /><span className="text-xs font-bold uppercase tracking-widest">Invite friends</span></div>
        <h3 className="font-display text-2xl font-bold">Give a month. Get a month.</h3>
        <p className="text-white/80 text-sm mt-1">When a friend upgrades to any paid plan, you both get <b>30 days of Pro on us</b>.</p>
      </div>
      <div className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="flex-1 bg-emerald-50 border border-emerald-100 rounded-full px-4 py-2.5 text-sm text-emerald-900 truncate">{link}</div>
          <Button onClick={copy} className="bg-emerald-700 hover:bg-emerald-800 text-white rounded-full h-10 px-4"><Copy className="w-4 h-4 mr-2" />Copy</Button>
        </div>
        <div className="flex gap-2 mb-6">
          <button onClick={shareTw} className="flex-1 h-10 rounded-full border border-emerald-950/10 hover:bg-emerald-50 text-emerald-950 text-sm font-medium inline-flex items-center justify-center gap-2"><Twitter className="w-4 h-4" /> X</button>
          <button onClick={shareWa} className="flex-1 h-10 rounded-full border border-emerald-950/10 hover:bg-emerald-50 text-emerald-950 text-sm font-medium inline-flex items-center justify-center gap-2"><MessageCircle className="w-4 h-4" /> WhatsApp</button>
          <button onClick={shareMail} className="flex-1 h-10 rounded-full border border-emerald-950/10 hover:bg-emerald-50 text-emerald-950 text-sm font-medium inline-flex items-center justify-center gap-2"><Mail className="w-4 h-4" /> Email</button>
        </div>
        <div className="grid grid-cols-3 gap-3 border-t border-emerald-950/5 pt-5">
          <div className="text-center"><div className="font-display text-2xl font-bold text-emerald-950">{data.invited_count}</div><div className="text-xs text-emerald-950/60">Friends joined</div></div>
          <div className="text-center"><div className="font-display text-2xl font-bold text-emerald-950">{data.rewarded_count}</div><div className="text-xs text-emerald-950/60">Upgrades</div></div>
          <div className="text-center"><div className="font-display text-2xl font-bold text-orange-500 inline-flex items-center gap-1"><Sparkles className="w-4 h-4" />{data.months_earned}</div><div className="text-xs text-emerald-950/60">Free months</div></div>
        </div>
      </div>
    </Card>
  );
};

export default ReferralCard;
